import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { persistStore, autoRehydrate } from 'redux-persist';
import storeReducer from './reducers';

const { apps } = require('./ecosystem.config.js');

const middlewares = [thunkMiddleware];
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const configureStore = () => {
	const store = createStore(
		storeReducer,
	  undefined,
		composeEnhancers(applyMiddleware(...middlewares), autoRehydrate())
	);

	let whitelist = ['client'];
	if(apps[0].isDev) {
		whitelist.push('home');
		whitelist.push('yates');
	};

	//persistStore(store);
	persistStore(store, { whitelist: whitelist });
	//persistStore(store).purge(); // to delete all data on persistStore.

	return store;
}

export default configureStore;
